"use client";

import { ComponentProps, useState, useEffect } from "react";
import { ArrowLeft } from "lucide-react";

import { NavMain } from "@/shared/components/ui/nav-main";
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/shared/components/ui/sidebar";
import { useTranslation } from "react-i18next";
import { settingLayoutNavItems } from "@/shared/constants/navbar-list-items/layouts-list-items";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/core/router/routes";
import { getUserWorkspaces } from "@/core/redux/thunks/workspaceThunk";
import { useDispatch } from "@/core/redux/store";
import { IWorkspace } from "@/shared/services/interface/responses/IWorkspaceResponses";

export function SettingSidebar({ ...props }: ComponentProps<typeof Sidebar>) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [workspaces, setWorkspaces] = useState<IWorkspace[] | undefined>(
    undefined
  );
  const [data, setData] = useState({
    navMain: settingLayoutNavItems(t),
  });

  const getWorkspaces = async () => {
    const response = await dispatch(getUserWorkspaces()).unwrap();

    if (response.success) {
      setWorkspaces(response.data.workspaces);
    }
  };

  useEffect(() => {
    getWorkspaces();
  }, []);

  useEffect(() => {
    setData({
      navMain: settingLayoutNavItems(t, workspaces),
    });
  }, [t, workspaces]);

  const backButton = () => {
    navigate(`/${ROUTES.Dashboard.Root}`);
  };

  return (
    <Sidebar variant="inset" {...props}>
      <SidebarHeader className="h-[40px]">
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="default" asChild>
              <a
                onClick={backButton}
                className="no-underline decoration-skip-ink-none underline-offset-[from-font] cursor-pointer gap-[8px]"
              >
                <div className="flex aspect-square size-4 items-center justify-center rounded-lg text-sidebar-primary font-600">
                  <ArrowLeft strokeWidth={2} size={16} color="#71717A" />
                </div>
                <div className="grid flex-1 text-[14px] leading-[20px] mt-[3px] font-600">
                  <span className="base-text">{t("back")}</span>
                </div>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
      </SidebarContent>
    </Sidebar>
  );
}
